import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class PersoneService extends BaseService {

  constructor(http: Http) {
    super(http)
  }

  /**
   * termina attivita per persona
   * @param reqBuilder 
   */
  terminaAttivita(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('persona/terminaAttivita', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Modifica del 26/11/2024 - Nuovo servizio di delete Persona
   * @param reqBuilder 
   */
  delete(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('persona/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
  * Save PERSONA
  * @param reqBuilder 
  */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('persona/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * update PERSONA
   * @param reqBuilder 
   */
  update(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('persona/update', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Get list of persone
   * @param reqBuilder 
   */
  getAllPersone(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('persona/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * report persone validate
   * @param reqBuilder 
   * @returns response for download
   */
   reportPersoneValidate(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('persona/ReportValidati', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * report persone censite
   * @param reqBuilder 
   * @returns response for download
   */
   reportPersoneCensite(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('persona/ReportCensiti', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

}